import { Context, useContext } from 'react';

/**
 * Consume a context but throw when used outside a provider.
 */
export function useNonNullableContext<T>(context: Context<T>, name?: string): NonNullable<T> {
  const maybeContext = useContext(context);
  if (maybeContext === null || maybeContext === undefined) {
    throw new Error(`context "${name}" was used without a Provider`);
  }
  return maybeContext;
}
